import { useState, useEffect } from 'react';

export default function SearchBar({ value, onChange, placeholder = 'Search...' }) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(localValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [localValue, onChange]);

  const isSearching = localValue.length > 0;

  return (
    <div className="relative group">
      <input
        type="search"
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        placeholder={placeholder}
        className={`
          w-full px-4 py-3.5 pl-12 pr-12
          bg-slate-800/70 backdrop-blur-sm
          border-2 rounded-xl
          text-white placeholder-slate-500
          transition-all duration-200
          ${isSearching
            ? 'border-accent-blue shadow-lg shadow-accent-blue/20'
            : 'border-slate-600/50 hover:border-slate-500 focus:border-accent-blue'
          }
          focus:ring-4 focus:ring-accent-blue/10 focus:outline-none
        `}
        aria-label={placeholder}
      />
      <div className={`
        absolute left-4 top-1/2 transform -translate-y-1/2
        transition-colors duration-200
        ${isSearching ? 'text-accent-blue' : 'text-slate-500 group-hover:text-slate-400'}
      `}>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      {localValue && (
        <button
          onClick={() => setLocalValue('')}
          className="absolute right-2 top-1/2 transform -translate-y-1/2
                     text-slate-500 hover:text-white hover:bg-slate-700
                     min-w-[40px] min-h-[40px] flex items-center justify-center
                     rounded-lg transition-all duration-200"
          aria-label="Clear search"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}
